import { dcActionTypes } from '../actions/dcActions';

const DCReducers = (state = { }, action) => {
  switch (action.type) {
  case dcActionTypes.GET_DC.LOADING: {
    const { getDCLoading } = action;
    return {
      ...state,
      getDCLoading,
    };
  }
  case dcActionTypes.GET_DC.SUCCESS: {
    const { deliveryChallans } = action;
    return {
      ...state,
      deliveryChallans,
    };
  }
  case dcActionTypes.GET_DC_BY_ID.LOADING: {
    const { getDCByIdLoading } = action;
    return {
      ...state,
      getDCByIdLoading,
    };
  }
  case dcActionTypes.GET_DC_BY_ID.SUCCESS: {
    const { selectedDC } = action;
    return {
      ...state,
      selectedDC,
    };
  }
  case dcActionTypes.CREATE_DC.LOADING: {
    const { createDCLoading } = action;
    return {
      ...state,
      createDCLoading,
    };
  }
  case dcActionTypes.UPDATE_DC.LOADING: {
    const { updateDCLoading } = action;
    return {
      ...state,
      updateDCLoading,
    };
  }
  case dcActionTypes.UPDATE_STATUS_DC.LOADING: {
    const { updateDCStatusLoading } = action;
    return {
      ...state,
      updateDCStatusLoading,
    };
  }
  case dcActionTypes.DELETE_DC.LOADING: {
    const { deleteDCLoading } = action;
    return {
      ...state,
      deleteDCLoading,
    };
  }
  case dcActionTypes.UPDATE_DC_WORKFLOW_STEP.LOADING: {
    const { updateDCWorkflowStepLoading } = action;
    return {
      ...state,
      updateDCWorkflowStepLoading,
    };
  }
  case dcActionTypes.UPDATE_DELIVERY_CHALLAN_STATUS.LOADING: {
    const { updateDeliveryChallanStatusLoading } = action;
    return {
      ...state,
      updateDeliveryChallanStatusLoading,
    };
  }
  case dcActionTypes.QUICK_UPDATE_DELIVERY_CHALLAN.LOADING: {
    const { quickUpdateDeliveryChallanLoading } = action;
    return {
      ...state,
      quickUpdateDeliveryChallanLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default DCReducers;
